export const ORIENTATION = {
  BUTTOM: 'buttom',
  RIGHT: 'right',
  LEFT: 'left'
};
